import { lazy } from 'react';
const DryerInq = lazy(() => import('./dryerinq'));

const dryerInqRoutes = [
  {
    path: '/dryerinq',
    component: DryerInq
  }
];

export default dryerInqRoutes;
